import {React,useState} from 'react'
import './Somes.css'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
import Collapsible from 'react-collapsible';
const Iq2 = () => {
    return (
        <div className='container'>
                 <NavLink to='/category/Interview question/10'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Interview question/8'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'80px'}}>&lt;- Previous page </Button>
</NavLink>
<div class="concepts">

</div>
<div>
<h1 class="h1"style={{float:'left'}}> Aptitude Questions</h1>
<h3 style={{float:'right'}}> Topics: <b>Stocks and Share</b></h3>
</div>

<br /> <br /> <br /> <br />

<br />
<td>


<p class="pq">1) What is the market price of a 9% share when a person gets 180 by investing Rs. 4000? </p>
<ol class="pointsu">
<li className='list'>150</li> 
<li className='list'>200</li> 
<li className='list'>250</li> 
<li className='list'>300</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'>  
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>Let the face value of the share = Rs. 100<br/>
Dividend per share = 9 <br/>
As per the question, an income of Rs. 180 is obtained from an investment of Rs. 4000.<br/>
So, an income of Rs. 9 is obtained from an investment of Rs. = (4000/180) * 9 = 200  <br/>  
So, the market price of the share = Rs. 200</p>
</div> </Collapsible>
<br />

<p class="pq">2) What will be the investment in order to obtain an income of 550 from 10% stock at Rs. 96?</p>
<ol class="pointsu">
<li className='list'>5280</li> 
<li className='list'>6280</li> 
<li className='list'>7280</li> 
<li className='list'>8280</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'>  
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>Market value = Rs. 96<br/>
Dividend = 10 % = Rs. 10 <br/>
The face value is not given, so let it be Rs. 100 <br/>
To obtain Rs. 10 (10 % of face value) the required investment = Rs. 96<br/>
To obtain Rs. 550, the required investment = 96/10 * 550 = 5280 </p>
</div> </Collapsible>
<br />

<p class="pq">3) A man buys Rs. 25 shares with 9% dividend. The man wants to have an interest of 15% on his money. Find the market value of each share? </p>
<ol class="pointsu">
<li className='list'>Rs. 17 </li>
<li className='list'>Rs. 13</li>
<li className='list'>Rs. 14</li>
<li className='list'>Rs. 15</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'>  
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>Face value of each share = Rs. 25</p>
<p>Dividend per share = 9% of 25 = 9/100 * 25 = 225/100</p>
<p>The man wants to earn an interest of 15% on his money:<br/>
So, money paid for a share *<img src="https://static.javatpoint.com/aptitude/images/stocks-and-shares-q3.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Stocks and Shares"/></p>
<img src="https://static.javatpoint.com/aptitude/images/stocks-and-shares-q3_1.png" alt="Apti Stocks and Shares"/>
<p>So, the market value of the share is Rs. 15</p>
</div> </Collapsible>
<br />

<p class="pq">4) What is the cost price of a Rs. 100 stock at 6 discount, when the brokerage is 2 %?</p>
<ol class="pointsu">
<li className='list'>98</li>
<li className='list'>99</li>
<li className='list'>96</li>
<li className='list'>97</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'>  
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>Face value = 100<br/>
Discount 6%<br/>
Brokerage = 2%<br/>
So, cost price = 100 - 6 + 2 = Rs. 96</p>
</div> </Collapsible>
<br />

<p class="pq">5) Ram invests in 16% stock at 74 and earns Rs. 1800. What is the investment made by Ram? </p>
<ol class="pointsu">
<li className='list'>8325</li>
<li className='list'>8328</li>
<li className='list'>8329</li>
<li className='list'>8324</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'>  
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>Market value = Rs. 74<br/>
Let the face value = Rs. 100<br/>
So, the dividend is 16% of the face value = Rs. 16<br/>
Now, to earn 16 the investment = Rs. 74<br/>
To earn Rs. 1800 the investment made would be =  <img src="https://static.javatpoint.com/aptitude/images/stocks-and-shares-q5.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Stocks and Shares"/> * 1800 = 8325</p>
</div> </Collapsible>
<br/>



<p class="pq">6) A man invested Rs. 1500 in a stock at 95 to obtain an income of Rs. 130. What is the dividend from the stock? </p>
<ol class="pointsu">
<li className='list'>8.32%</li> 
<li className='list'>7.32%</li> 
<li className='list'>6.32%</li> 
<li className='list'>5.32%</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'>  
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>By investing Rs. 1500, the man obtained an income of Rs. 130.<br/>
So, by investing Rs. 95, the income will be = <img src="https://static.javatpoint.com/aptitude/images/stocks-and-shares-q6.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Stocks and Shares"/>* 96 = Rs. 8.32<br/> 
So, the dividend = 8.32% </p>
</div> </Collapsible>
<br />

<p class="pq">7) Naresh invested Rs. 5940 in Rs. 20 shares quoted at Rs. 18. If the rate of dividend is 15%, find his annual income. </p>
<ol class="pointsu">
<li className='list'>990 </li> 
<li className='list'>890</li> 
<li className='list'>790</li> 
<li className='list'>690</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'>  
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>Market value of the share: Rs. 18<br/>
Investment = Rs. 5940<br/>
Number of shares = 5940 /18 = 330 <br/>
Face value of the share = Rs. 20<br/>
Dividend = 15% <br/>
Dividend per share = 20 * <img src="https://static.javatpoint.com/aptitude/images/stocks-and-shares-q7.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Stocks and Shares"/>= Rs. 3</p>
<p>His annual income = number of shares * dividend per share<br/>
                                  = 330 * 3 = Rs. 990 </p>
</div> </Collapsible>
<br />

<p class="pq">8) Suresh bought 80 shares of Rs. 60 at 6 discount. If the rate of the dividend is 12 %, find the rate of interest obtained. </p>
<ol class="pointsu">
<li className='list'>9.4% </li>
<li className='list'>10.4% </li>
<li className='list'>12.3% </li>
<li className='list'>13.3% </li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'>  
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>Given that, the face value of a share = Rs. 60 <br/>
The price at which the share is bought = Rs. 60 - Rs. 6 = Rs. 54  <br/>
 The number of shares = 80 <br/>
So, total investment = 80 * 54 = Rs. 4320<br/> 
Dividend = 12% <br/>
Dividend per share = 60 * 12/100 = 7.2<br/>
Total dividend = 80 * 7.2 = 576 <br/>
He earned a dividend of 576 for an investment of Rs. 4320 <br/>
So, the interest obtained = <img src="https://static.javatpoint.com/aptitude/images/stocks-and-shares-q8.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Stocks and Shares"/>* 100 = 13.3% </p>
</div> </Collapsible>
<br />

<p class="pq">9) Find the income on <img src="https://static.javatpoint.com/aptitude/images/stocks-and-shares-q9.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Stocks and Shares"/>% stock of Rs. 4000 purchased at Rs. 90.</p>
<ol class="pointsu">
<li className='list'>Rs. 240 </li>
<li className='list'>Rs. 140</li>
<li className='list'>Rs. 340</li>
<li className='list'>Rs. 540</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'>  
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>Face value of the stock = Rs. 4000</p>
<p>Annual Dividend = 8<img src="https://static.javatpoint.com/aptitude/images/stocks-and-shares-q9.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Stocks and Shares"/> = <img src="https://static.javatpoint.com/aptitude/images/stocks-and-shares-q9_1.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Stocks and Shares"/> % of the face value.</p>
<p>So, income = 4000 * <img src="https://static.javatpoint.com/aptitude/images/stocks-and-shares-q9_2.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Stocks and Shares"/> = Rs. 340 </p>
</div> </Collapsible>
<br />

<p class="pq">10) Suresh buys 100 shares of par value Rs. 7 each, of a company, which pays an annual dividend of 12% at such a price that he gets 10% on his investment. What is the market value of the share? </p>
<ol class="pointsu">
<li className='list'>Rs. 8.4</li>
<li className='list'>Rs. 6.4</li>
<li className='list'>Rs. 7.4</li>
<li className='list'>Rs. 9.4</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'>  
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>The face value of each share = Rs. 7<br/>
Total dividend received = 100 * 7 * <img src="https://static.javatpoint.com/aptitude/images/stocks-and-shares-q10.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Stocks and Shares"/> = 84 </p>
<p>Let the market value of 100 shares = x<br/>
x * <img src="https://static.javatpoint.com/aptitude/images/stocks-and-shares-q10_1.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Stocks and Shares"/> = 84</p>
<p>x = 840 <br/>
Now, the market value of 100 shares = 840<br/>
So, the market value of single share = Rs.8.4 </p>
</div> </Collapsible>
<br/>
<p class="pq">16) To obtain an annual income of Rs. 900 from a 9% stock at 90, the amount to be invested on stocks is: </p>
<ol class="pointsu">
<li className='list'>Rs. 12000</li> 
<li className='list'>Rs. 11000</li> 
<li className='list'>Rs. 10000</li> 
<li className='list'>Rs. 14000</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'>  
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>Since face value is not given, let it be Rs. 100  <br/>
As it is an 9% stock, income (dividend) per stock = Rs. 9<br/>
Now, for an income of Rs. 9 the amount invested or the price of the stock = Rs. 100<br/>
For an income of Rs. 900, the amount invested in buying the stocks = Rs.<img src="https://static.javatpoint.com/aptitude/images/stocks-and-shares-q16.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Stocks and Shares"/>* 900 = Rs. 10,000 </p>
</div> </Collapsible>


<br/>

</td>

        </div>
    )
}

export default Iq2
